import {
  Box,
  Container,
  Flex,
  Price,
  PrimaryButton,
  Stack,
  Text,
} from "flicket-ui";
import { useState, ReactNode } from "react";
import { useIntersectionObserver } from "usehooks-ts";
import { FixedRatioImage, SlateRenderer } from "~components";
import Modal, { ModalProps } from "~components/common/Modal";
import { IReleaseTicket } from "~features/nonseated-reservation/nonseated-reservation.types";
import { ImageGalleryFragmentFragment, ImageGalleryItem } from "~graphql/sdk";
import { useIsMobile } from "~hooks";
import { hasRichTextContent } from "~lib/helpers/hasRichTextContent";

interface IZoneModal extends Pick<ModalProps, "isOpen" | "close"> {
  imageGallery: ImageGalleryFragmentFragment[];
  title: string;
  description: string;
  stickySection: ReactNode;
  mobileFooter?: ReactNode;
}

export const DetailsModal = (props: IZoneModal) => {
  return (
    <Modal
      alignModalTop={true}
      isOpen={props.isOpen}
      close={props.close}
      maxWidth="100%"
      width="100%"
      clickOutsideToClose={true}
    >
      <ModalContent {...props} />
    </Modal>
  );
};

function ModalContent(props: IZoneModal) {
  const {
    imageGallery,
    title,
    description,
    stickySection,
    mobileFooter,
  } = props;
  const isMobile = useIsMobile("sm");

  return (
    <>
      <Modal.Content p={{ sm: 4 }}>
        <Box>
          {imageGallery?.[0] && (
            <FixedRatioImage
              src={imageGallery?.[0].original.src}
              alt={title}
              ratio={"196 / 130"}
              width={{ _: "100%" }}
              borderRadius={{ sm: "sm" }}
              backgroundColor="N100"
            />
          )}
        </Box>

        <Modal.StickySection>
          {({ isSticky }) => (
            <Box px={{ _: 0, sm: 0 }}>
              <Stack
                direction="horizontal"
                gap={3}
                justifyContent="space-between"
                flex={1}
                py={3}
                // pl={isSticky ? 4 : 0}
                // pr={isSticky ? 6 : 0}
                boxShadow={isSticky ? "card" : "none"}
                backgroundColor="white"
                borderBottom="1px solid #E5E5E5"
              >
                {typeof stickySection === "function"
                  ? stickySection({ isSticky })
                  : stickySection}
              </Stack>
            </Box>
          )}
        </Modal.StickySection>
        {hasRichTextContent(description) && (
          <Box mt={3} px={{ _: 2, sm: 0 }}>
            <SlateRenderer value={description} />
          </Box>
        )}
      </Modal.Content>
      {isMobile && mobileFooter && (
        <Modal.Footer boxShadow="card">{mobileFooter}</Modal.Footer>
      )}
    </>
  );
}
